import "./index.css";

import * as Sentry from "@sentry/react";

import App from "@/app";
import ReactDOM from "react-dom/client";
import { StrictMode } from "react";

// CRITICAL: Clean up Stripe OAuth parameters BEFORE React/Convex Auth initializes
// This prevents Convex Auth from seeing the 'code' parameter and throwing "Invalid verification code"
const currentPath = window.location.pathname;
const urlParams = new URLSearchParams(window.location.search);

if (
  currentPath === "/affiliates" &&
  (urlParams.has("code") || urlParams.has("error"))
) {
  console.log(
    "PRE-REACT: Detected Stripe OAuth callback, preserving parameters in sessionStorage",
  );

  // Store parameters in sessionStorage for the affiliates component to use
  if (urlParams.has("code")) {
    sessionStorage.setItem("stripe_oauth_code", urlParams.get("code") || "");
  }
  if (urlParams.has("error")) {
    sessionStorage.setItem("stripe_oauth_error", urlParams.get("error") || "");
  }
  if (urlParams.has("error_description")) {
    sessionStorage.setItem(
      "stripe_oauth_error_description",
      urlParams.get("error_description") || "",
    );
  }
  if (urlParams.has("state")) {
    sessionStorage.setItem("stripe_oauth_state", urlParams.get("state") || "");
  }

  // Immediately clean the URL to prevent Convex Auth from processing these parameters
  const cleanUrl = window.location.pathname;
  window.history.replaceState({}, document.title, cleanUrl);
  console.log("PRE-REACT: URL cleaned, parameters preserved in sessionStorage");
}

Sentry.init({
  dsn: "https://356648c869b2831c8ba8fe47198fdde9@o4509678469185536.ingest.de.sentry.io/4509684858224720",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment:
    import.meta.env.VITE_CONVEX_URL.includes("frugal-fly") ||
    import.meta.env.VITE_CONVEX_URL.includes("creatorgrid")
      ? "production"
      : "development",
});

// Render the app
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
